import React from 'react'
import prefetchCmsPage from 'graphql/prefetchers/prefetchCmsPage'
import { initializeApollo } from 'lib/apolloClient'
import { setCacheControlHeader } from 'lib/cache'
import { isServer } from 'lib/utils'

import CmsPage from 'components/CmsPage/CmsPage'
import useRouter from 'hooks/useRouter'

function CmsPageBySlug() {
  const router = useRouter()
  const { slug } = router.query

  return (
    <>
      <CmsPage slug={slug} wrapItems includeLayoutWithHeader />
    </>
  )
}

CmsPageBySlug.getInitialProps = async (ctx) => {
  if (isServer()) {
    setCacheControlHeader({ ctx, ttl: 900 })
    const apolloClient = initializeApollo(ctx)
    await prefetchCmsPage(apolloClient, { slug: ctx.query.slug })

    return {
      initialApolloState: apolloClient.cache.extract(),
    }
  }

  return {}
}

export default CmsPageBySlug
